//
// Module for the ParticiapantAccountReview Index view
//
rs.module("content/fund/participantaccountreview/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {

            var filter = $.js(jsSelectors.filter);

            var auditTypeDropDown = filter.js(jsSelectors.auditTypeDropDown);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // listen for audit type dropdown change
            auditTypeDropDown.change(auditStatusChanged);

            // Hookup Ajax to changing the selected audit status
            function auditStatusChanged() {

                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { selectedAuditStatus: auditTypeDropDown.val() },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);